module.exports = __webpack_public_path__ + "img/9.cbc01670.jpg";